import { createSlice } from '@reduxjs/toolkit';

/*

  { files: [], id: xxx }

*/
export const getFileLog = (fileLog, id) =>
  fileLog.log.find((item) => item._id === id);

const filesLog = createSlice({
  name: 'filesLog',
  initialState: { log: [] },
  reducers: {
    uploadLogFile: (state, action) => {
      const file = action.payload.file;
      const id = action.payload.id;

      const alreadyExists = state.log.find((item) => item._id === id);

      if (alreadyExists) {
        state.log = state.log.map((item) =>
          item._id === id
            ? (item = { ...item, files: [...item.files, file] })
            : item
        );
      } else {
        state.log.push({ file, _id: id });
      }
    },
    removeLogFile: (state, action) => {
      const id = action.payload.id;
      const fileId = action.payload.fileId;

      state.log = state.log.map((item) =>
        item.id === id
          ? (item = {
              ...item,
              files: item.files.filter((f) => f._id !== fileId),
            })
          : item
      );
    },

    getLogFiles: (state, action) => {
      const files = action.payload.files;
      const id = action.payload.id;
      const alreadyExists = state.log.find((item) => item._id === id);

      if (alreadyExists) {
        state.log = state.log.map((item) =>
          item._id === id ? (item = { ...item, files }) : item
        );
      } else {
        state.log.push({ files, _id: id });
      }
    },
  },
  clearLogFile: (state) => {
    state.log = [];
  },
});
export const { uploadLogFile, getLogFiles, removeLogFile } = filesLog.actions;
export default filesLog.reducer;
